import { t } from "i18next";
import toast from "react-hot-toast";
import { SnackbarError } from "../components/base/SnackbarAlert/SnackbarError";
import { SnackbarSuccess } from "../components/base/SnackbarAlert/SnackbarSuccess";

export function useToasts() {
    function success(message, options) {
        toast.custom(() => <SnackbarSuccess message={message} />, {
            position: "bottom-right",
            ...options,
        });
    }

    function error(message, options) {
        toast.custom(() => <SnackbarError message={message} />, {
            position: "bottom-right",
            ...options,
        });
    }

    function onFormErrors(errors) {
        Object.entries(errors).forEach(([key, value]) => {
            if (!value) {
                return;
            }
            // @ts-ignore
            error(value.message);
        });
    }

    function onServerError(serverError) {
        console.log("Server error:", serverError);

        const getErrorMessage = (errorCode) => {
            console.log("errorCode", errorCode);
            switch (errorCode) {
                case "duplicate_pesel":
                    return t("clients.passportDialog.duplicatePeselError");
                case "duplicate_id_card":
                    return t("clients.passportDialog.duplicateIdCardError");
                case "duplicate_passport":
                    return t("clients.passportDialog.duplicatePassportError");
                case "enter_a_valid_email_address":
                    return t("clients.passportDialog.enterAValidEmailAddressError");
                case "bank_with_this_bank_name_already_exists":
                    return t("bankings.bank_with_this_bank_name_already_exists");
                case "banking_with_this_banking_name_already_exists":
                    return t("bankings.banking_with_this_banking_name_already_exists");
                case "banking_with_this_banking_nr_already_exists":
                    return t("bankings.banking_with_this_banking_nr_already_exists");
                case "bank_matching_query_does_not_exist":
                    return t("bankings.bank_matching_query_does_not_exist");
                case "bankingkind_matching_query_does_not_exist":
                    return t("bankings.bankingkind_matching_query_does_not_exist");
                case "invest_matching_query_does_not_exist":
                    return t("bankings.invest_matching_query_does_not_exist");
                case "banking_nr_must_have_exactly_26_characters":
                    return t("bankings.banking_nr_must_have_exactly_26_characters");
                case "invalid_format_of_banking_nr":
                    return t("bankings.invalid_format_of_banking_nr");
                case "translated_error":
                    return t(serverError.response.data.translation_key);
                default:
                    return serverError?.response?.data?.message || "Wystąpił nieznany błąd.";
            }
        };

        const errorCode = serverError?.response?.data?.error_code || "";
        const errorMessage = getErrorMessage(errorCode);

        error(errorMessage);
    }

    return {
        success,
        error,
        onFormErrors,
        onServerError,
    };
}
